import { Box, Heading } from '@simplywallst/ui-core';

interface Props {
  content: React.ReactNode;
}

const ScreenerCarousel = ({ content }: Props) => {
  return (
    <Box
      marginTop="x2"
      marginTopMd="x4"
      marginBottom="x2"
      paddingY="x2"
      paddingLeft="x0"
      paddingRight="x0"
      borderRadiusLg="x1_5"
      backgroundColor="noir"
    >
      <Box paddingLeft="x2" paddingLeftMd="x3" paddingBottom="x1">
        <Heading
          data-cy-id="stock-screens-title"
          as="h2"
          typography="xLargeStrong"
        >
          Stock Screens
        </Heading>
      </Box>
      {content}
    </Box>
  );
};

export default ScreenerCarousel;
